function safeAssign(target, ...args) {
  Object.assign(target, ...args);
}

export { safeAssign };
//# sourceMappingURL=tsHelpers.js.map
